export default "__VITE_ASSET__Cz0H_Q7x__"